import { withQuery } from './stringUtils';

interface ImgixOptions {
  auto?: string;
  crop?: string;
  w?: number;
  h?: number;
  ar?: string;
  fit?: string;
  rect?: string;
  'max-w'?: number;
  'max-h'?: number;
  'min-w'?: number;
  'min-h'?: number;
}

const withImgix = (url: string, options: ImgixOptions = {}) =>
  withQuery(url, {
    auto: 'compress',
    ...options,
  });

export default withImgix;
